import { render, staticRenderFns } from "./customerOrder.vue?vue&type=template&id=0be8791e&scoped=true&"
import script from "./customerOrder.vue?vue&type=script&lang=js&"
export * from "./customerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8791e",
  null
  
)

export default component.exports